import { Link } from "@tanstack/react-router";
import type { ReactNode } from "react";

import { DravianLogo } from "./logo";
import { StatusChips } from "./status-chips";
import { UserMenu } from "./user-menu";

export function TopBar({
  center,
  logoHref = "/hq",
  hideLogo = false,
}: {
  center?: ReactNode;
  logoHref?: string;
  hideLogo?: boolean;
}) {
  return (
    <header className="flex items-center justify-between border-b border-border bg-background/80 backdrop-blur px-5 h-[68px] shrink-0">
      {!hideLogo && (
        <Link to={logoHref} className="shrink-0">
          <DravianLogo />
        </Link>
      )}
      <div className="flex-1 px-6 min-w-0">{center}</div>
      <div className="flex items-center gap-3">
        <StatusChips />
        <UserMenu />
      </div>
    </header>
  );
}